import {inject} from "vue";

export default () => {
    const $papa = inject('$papa');

    const parseCSV = (file) => {
        return new Promise((resolve, reject) => {
            $papa.parse(file, {
                complete: (parseResult) => {
                    if (!parseResult.data) {
                        reject('Parsing error');
                    }
                    resolve(parseResult.data);
                }
            });
        });
    }

    const validateEmail = (email) => {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    };

    const uniqueEmails = (emailsArray) => {
        return emailsArray.filter((value, index, self) => {
            return !value.length || (value.length && self.indexOf(value) === index);
        });
    }

    const validateEmailAddresses = (emailAddresses) => {
        let valid = true;
        emailAddresses.some((emailAddress) => {
            if (emailAddress.length && !validateEmail(emailAddress)) {
                valid = false;
                return true;
            }
            return false;
        });
        if (!valid) {
            return {
                valid: false,
                error: "The list contains invalid email addresses",
            };
        }

        if (uniqueEmails(emailAddresses).length !== emailAddresses.length) {
            return {
                valid: false,
                error: "The list contains duplicate email addresses",
            };
        }

        return {
            valid: true,
            error: null,
        };
    }

    return {
        parseCSV,
        validateEmail,
        validateEmailAddresses
    }
}
